import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import MroEditForm from "./Forms/MroEditForm";
import { TitleMro } from "./Constant/Source";

const MroEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleMro.edit} component="div">
      <MroEditForm {...props} />
    </Edit>
  );
};

export default MroEdit;
